import { LoaderFunctionArgs } from "react-router";
import { handleApiFetch } from "../../utils";

export async function searchingLoader({
    request,
    context: loaderContext,
}: LoaderFunctionArgs<any>) {
    let context = loaderContext;
    if (typeof window !== "undefined" && window.__client_context) {
        context = window.__client_context
    }
    
    if (context == null) return {};
    const url = new URL(request.url);

    const searchQuery = url.searchParams.get("q");
    const articles = await handleApiFetch(
        context.env,
        `/wiki/articles?search=${searchQuery}`
    );

    return { articles };
}
